import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { PlainText } from "../PlainText";
import { injectIntl, FormattedMessage } from "react-intl";

class TakeawayMessagesBase extends React.Component {
  render() {
    const { intl } = this.props;
    return (
      <div
        className={this.props.className}
        style={{
          background: this.props.caption ? "white" : null,
          borderRadius: this.props.caption ? "5px" : null,
          border: this.props.caption ? "1px solid #ccd8e1" : null,
          paddingTop: this.props.caption ? "8px" : null,
        }}
        dir="auto"
      >
        <h5
          style={{
            marginTop: this.props.description ? 16 : 0,
            marginLeft: this.props.caption ? "8px" : null,
          }}
        >
          <FormattedMessage
            id={this.props.heading}
            defaultMessage={this.props.heading}
          />
        </h5>
        <p style={{ marginTop: this.props.heading ? 16 : 0 }}>
          <PlainText text={this.props.description} />
        </p>
        <ul
          style={{
            marginTop: this.props.description ? 16 : 0,
            padding: this.props.caption ? "0 8px" : null,
          }}
        >
          {this.props.items.map((item, index) => {
            return (
              <li key={item + index}>
                <div className="img-container">
                  <img
                    tabIndex={0}
                    src={item.image}
                    alt={intl.formatMessage({
                      id: item.message,
                      defaultMessage: item.message,
                    })}
                  />
                </div>
                <div className="tip">
                  <p tabIndex={0}>
                    <FormattedMessage
                      id={item.message}
                      defaultMessage={item.message}
                    />
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
        {this.props.caption ? (
          <p className="caption">
            <PlainText text={this.props.caption} />
          </p>
        ) : null}
      </div>
    );
  }
}

TakeawayMessagesBase.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  items: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TakeawayMessagesBase.defaultProps = {
  className: "takeawayMessages",
};

export const TakeawayMessages = injectIntl(TakeawayMessagesBase);
